var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"com-capsule-text",style:({ background: _vm.bgColor })},[_vm._v(" "+_vm._s(_vm.emptyToLine(_vm.statusDesc))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }